/* alb-filter-vergleich-wahl · Web Component <alb-filter-vergleich-wahl>
   Spaltenwechsel der Section "ALB Filter-Vergleich Wahl".
   · Zeile 1 jeder Spalte: Text-Button (.alb-sfw-pickbtn); die leere Spalte hat zusätzlich
     einen Outline-Button (.alb-sfw-emptybtn). Beide öffnen das EINE Listbox-Menü der
     Section (.alb-sfw-menu, Optionen .alb-sfw-opt[data-idx]), das beim Öffnen in den
     .alb-sfw-pick-Container des jeweiligen Slots gehängt wird (Positionierung per CSS).
   · Spalten werden BEWEGT, nicht geklont: Pool-Produkte, die gerade nicht sichtbar sind,
     liegen als <template class="alb-sfw-tpl" data-idx data-handle> im Element; beim Wechsel
     wandert die alte .alb-sfw-col in ein neues Template (stash) und die neue aus ihrem
     Template in den Slot. So steht jede Spalte genau einmal im HTML.
   · Produkte, die bereits in einer Spalte stehen, sind im Menü ausgeblendet (refreshMenu).
   · Leeren lässt sich nur Spalte 3; Spalte 1 + 2 bleiben immer belegt.
   · Auswahl wird je Section in sessionStorage gemerkt (data-key) und beim nächsten
     Seitenaufruf wiederhergestellt – ausser im Theme-Editor und im festen Modus
     (data-fixed, Pool ≤ 3). data-keep (PDP) pinnt Spalte 1 auf das aktuelle Produkt.
   · Tastatur: Enter/Space/Pfeil öffnet, Pfeile navigieren, Enter wählt, Escape schliesst.
   · Theme-Editor: Klick auf einen Block „Vergleichsprodukt“ zeigt ihn in Spalte 3. */
(function () {
  if (customElements.get('alb-filter-vergleich-wahl')) return;

  class AlbFilterVergleichWahl extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.tpls = {};
      this.querySelectorAll('template.alb-sfw-tpl').forEach(function (t) { self.tpls[t.dataset.idx] = t; });
      this.emptyTpl = this.querySelector('template.alb-sfw-tpl-empty');
      this.menuEl = this.querySelector('.alb-sfw-menu');
      this.key = this.dataset.key || 'alb-sfw';
      if (this.dataset.fixed || !this.menuEl) return; /* fester Modus: nichts zu schalten */

      this.addEventListener('click', function (e) {
        var t = e.target;
        var opt = t.closest('.alb-sfw-opt');
        if (opt && self.contains(opt)) {
          e.preventDefault();
          var slot = opt.closest('.alb-sfw-slot');
          self.closeAll();
          if (slot) {
            self.choose(slot, opt.dataset.idx || '');
            var btn = slot.querySelector('.alb-sfw-pickbtn');
            if (btn) btn.focus();
          }
          return;
        }
        var trigger = t.closest('.alb-sfw-pickbtn, .alb-sfw-emptybtn');
        if (trigger && self.contains(trigger)) {
          e.preventDefault();
          self.toggle(trigger.closest('.alb-sfw-slot'));
        }
      });

      this.addEventListener('keydown', function (e) { self.onKey(e); });

      this._docClick = function (e) { if (!self.contains(e.target)) self.closeAll(); };
      document.addEventListener('click', this._docClick);

      if (!(window.Shopify && window.Shopify.designMode)) this.restore();
    }

    disconnectedCallback() {
      if (this._docClick) document.removeEventListener('click', this._docClick);
    }

    slots() { return Array.prototype.slice.call(this.querySelectorAll('.alb-sfw-slot')); }

    col(slot) { return slot.querySelector('.alb-sfw-col:not(.alb-sfw-col--empty)'); }

    current(slot) { var c = this.col(slot); return c ? c.dataset.idx : ''; }

    /* Handle → Pool-Index über sichtbare Spalten UND Templates */
    idxByHandle(handle) {
      var hit;
      this.slots().forEach(function (s) { var c = s.querySelector('.alb-sfw-col'); if (c && c.dataset.handle === handle) hit = c.dataset.idx; });
      if (hit !== undefined) return hit;
      var keys = Object.keys(this.tpls);
      for (var i = 0; i < keys.length; i++) if (this.tpls[keys[i]].dataset.handle === handle) return keys[i];
      return undefined;
    }

    /* ---- Popover ---- */
    toggle(slot) {
      if (!slot) return;
      var open = slot.classList.contains('is-open');
      this.closeAll();
      if (!open) this.open(slot);
    }

    open(slot) {
      var pick = slot.querySelector('.alb-sfw-pick');
      var btn = slot.querySelector('.alb-sfw-pickbtn');
      var menu = this.menuEl;
      if (!pick || !menu) return;
      pick.appendChild(menu);
      this.refreshMenu(slot);
      menu.hidden = false;
      slot.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      var first = menu.querySelector('.alb-sfw-opt:not([hidden])');
      if (first) first.focus();
    }

    closeAll() {
      if (this.menuEl) this.menuEl.hidden = true;
      this.slots().forEach(function (slot) {
        slot.classList.remove('is-open');
        var btn = slot.querySelector('.alb-sfw-pickbtn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    /* Bereits gezeigte Produkte ausblenden; „Spalte leeren“ nur für Slot 3 */
    refreshMenu(slot) {
      var self = this;
      var shown = {};
      this.slots().forEach(function (s) { var c = self.current(s); if (c !== '') shown[c] = true; });
      var cur = slot ? this.current(slot) : '';
      this.menuEl.querySelectorAll('.alb-sfw-opt').forEach(function (o) {
        if (o.classList.contains('alb-sfw-opt--none')) {
          o.hidden = !(slot && slot.dataset.slot === '3' && cur !== '');
          return;
        }
        o.hidden = !!shown[o.dataset.idx];
        o.setAttribute('aria-selected', 'false');
      });
    }

    onKey(e) {
      var slot = e.target.closest ? e.target.closest('.alb-sfw-slot') : null;
      if (!slot) return;
      var menu = this.menuEl;
      var inMenu = menu && !menu.hidden && menu.contains(e.target);
      if (e.key === 'Escape') {
        if (slot.classList.contains('is-open')) {
          e.preventDefault();
          this.closeAll();
          var btn = slot.querySelector('.alb-sfw-pickbtn');
          if (btn) btn.focus();
        }
        return;
      }
      var onTrigger = e.target.matches && e.target.matches('.alb-sfw-pickbtn, .alb-sfw-emptybtn');
      if (onTrigger && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        e.preventDefault();
        if (!slot.classList.contains('is-open')) { this.closeAll(); this.open(slot); }
        return;
      }
      if (!inMenu) return;
      var opts = Array.prototype.slice.call(menu.querySelectorAll('.alb-sfw-opt:not([hidden])'));
      var i = opts.indexOf(e.target);
      if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
      else if (e.key === 'Home') { e.preventDefault(); opts[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); opts[opts.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.closeAll();
        this.choose(slot, e.target.dataset.idx || '');
        var b = slot.querySelector('.alb-sfw-pickbtn');
        if (b) b.focus();
      } else if (e.key === 'Tab') {
        this.closeAll();
      }
    }

    /* ---- Spalten bewegen ---- */
    /* Sichtbare Spalte aus dem Slot nehmen und als Template stashen (leere Spalte wird verworfen) */
    detach(slot) {
      var c = slot.querySelector('.alb-sfw-col');
      if (!c) return;
      c.remove();
      if (c.classList.contains('alb-sfw-col--empty')) return;
      var tpl = document.createElement('template');
      tpl.className = 'alb-sfw-tpl';
      tpl.dataset.idx = c.dataset.idx;
      tpl.dataset.handle = c.dataset.handle || '';
      tpl.content.appendChild(c);
      this.appendChild(tpl);
      this.tpls[tpl.dataset.idx] = tpl;
    }

    /* Slot (bereits leer) mit Pool-Index idx füllen; '' = leere Spalte */
    fill(slot, idx) {
      var tpl = idx !== '' ? this.tpls[idx] : null;
      if (tpl) {
        var c = tpl.content.firstElementChild;
        tpl.remove();
        delete this.tpls[idx];
        if (c) slot.appendChild(c);
      } else if (this.emptyTpl) {
        slot.appendChild(this.emptyTpl.content.cloneNode(true));
      }
      slot.classList.toggle('is-empty', !tpl);
      var txt = slot.querySelector('.alb-sfw-pickbtn-text');
      if (txt) txt.textContent = tpl ? (this.dataset.labelSwitch || 'Produkt wechseln') : (this.dataset.labelPick || 'Produkt wählen');
      var short = slot.querySelector('.alb-sfw-pickbtn-short');
      if (short) short.textContent = tpl ? (this.dataset.labelSwitchShort || 'Wechseln') : (this.dataset.labelPickShort || 'Wählen');
    }

    /* Ziel-Belegung aller Slots setzen: erst alles stashen, dann füllen (so klappt auch ein Tausch) */
    arrange(targets) {
      var self = this;
      var slots = this.slots();
      slots.forEach(function (s) { self.detach(s); });
      slots.forEach(function (s, i) { self.fill(s, targets[i] === undefined ? '' : targets[i]); });
    }

    choose(slot, newIdx) {
      if (!slot) return;
      var self = this;
      var slots = this.slots();
      var targets = slots.map(function (s) { return self.current(s); });
      var pos = slots.indexOf(slot);
      var oldIdx = targets[pos];
      if (newIdx === oldIdx) return;
      if (newIdx === '') {
        if (slot.dataset.slot !== '3') return; /* Spalte 1 + 2 bleiben belegt */
      } else {
        var other = targets.indexOf(newIdx);
        if (other >= 0) targets[other] = oldIdx; /* Sicherheitsnetz: Doppelwahl tauscht */
      }
      targets[pos] = newIdx;
      this.arrange(targets);
      this.flash(slot);
      this.save();
    }

    flash(slot) {
      slot.classList.remove('is-swapped');
      void slot.offsetWidth;
      slot.classList.add('is-swapped');
      setTimeout(function () { slot.classList.remove('is-swapped'); }, 400);
    }

    /* ---- Merken ---- */
    save() {
      var self = this;
      try {
        var handles = this.slots().map(function (s) { var c = self.col(s); return c ? c.dataset.handle : ''; });
        sessionStorage.setItem(self.key, JSON.stringify(handles));
      } catch (e) { /* Storage gesperrt – dann eben ohne Merken */ }
    }

    restore() {
      var stored = null;
      try { stored = JSON.parse(sessionStorage.getItem(this.key) || 'null'); } catch (e) { return; }
      if (!Array.isArray(stored) || stored.length !== 3) return;
      var self = this;
      var slots = this.slots();
      var idxs = stored.map(function (h) { var i = h ? self.idxByHandle(h) : undefined; return i === undefined ? '' : i; });
      var keep = this.dataset.keep ? this.idxByHandle(this.dataset.keep) : undefined;
      if (keep !== undefined) {
        idxs[0] = keep;
        idxs = idxs.map(function (v, i) { return i > 0 && v === keep ? '' : v; });
      }
      /* Spalte 1 + 2 dürfen nicht leer werden – dann aktuelle Belegung behalten */
      var cur = slots.map(function (s) { return self.current(s); });
      for (var k = 0; k < 2; k++) if (idxs[k] === '') idxs[k] = cur[k];
      var filled = idxs.filter(function (v) { return v !== ''; });
      var uniq = filled.filter(function (v, i) { return filled.indexOf(v) === i; });
      if (uniq.length !== filled.length) return;
      var same = slots.every(function (s, i) { return self.current(s) === (idxs[i] || ''); });
      if (!same) this.arrange(idxs.slice(0, slots.length));
    }

    /* ---- Theme-Editor ---- */
    showBlock(blockId) {
      var self = this;
      var slots = this.slots();
      var visible = slots.some(function (s) { var c = s.querySelector('.alb-sfw-col'); return c && c.dataset.blockId === blockId; });
      if (visible) return;
      var idx;
      Object.keys(this.tpls).forEach(function (k) {
        var c = self.tpls[k].content.querySelector('.alb-sfw-col');
        if (c && c.dataset.blockId === blockId) idx = k;
      });
      if (idx === undefined) return;
      var targets = slots.map(function (s) { return self.current(s); });
      var pos = targets.indexOf('');
      if (pos < 0) pos = slots.length - 1;
      targets[pos] = idx;
      this.arrange(targets);
      this.flash(slots[pos]);
    }
  }

  customElements.define('alb-filter-vergleich-wahl', AlbFilterVergleichWahl);

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('alb-filter-vergleich-wahl') : null;
    if (root && e.detail && e.detail.blockId && root.showBlock) root.showBlock(e.detail.blockId);
  });
})();
